<template>
  <v-container
    fluid
    pa-0
    fill-height
    class="align-start"
    style="max-width: 100%"
  >
    <div class="d-flex flex-column flex-grow-1 fill-height">
      <div class="d-flex">
        <EventContainer />
      </div>
      <v-divider></v-divider>
      <transition name="slide-y-transition" mode="out-in">
        <InputOutputContainerLoader
          v-if="selectedEventUUID"
          :key="selectedEventUUID"
        />
        <div
          class="flex-column text-center d-flex flex-grow-1 align-center justify-center"
          v-else
        >
          <p class="text-h5 d-flex align-center">
            <v-icon class="pr-4">mdi-information-outline</v-icon>
            Välj en händelse
          </p>
          <p class="text-subtitle-1 text--secondary" style="width: 390px">
            Välj en händelse genom att trycka på ett händelsekort för att se och
            uppdatera information.
          </p>
        </div>
      </transition>
    </div>
  </v-container>
</template>

<script>
import EventContainer from '@/modules/event/components/EventContainer'
import InputOutputContainerLoader from '@/components/InputOutputContainerLoader'
import { get } from 'vuex-pathify'

export default {
  name: 'Dsp',

  components: {
    EventContainer,
    InputOutputContainerLoader
  },

  computed: {
    selectedEventUUID: get('event/selectedUUID')
  },

  beforeDestroy() {
    this.$store.set('event/selectedUUID', null)
    this.$store.commit('trafficMessage/resetModel')
    this.$store.commit('duaMessage/resetModel')
    this.$store.set('duaMessage/form', {})
  }
}
</script>
